import axios from "axios";
import { Message, Loading } from "element-ui";
import db from "@/utils/localstorage.js";
import router from "@/router";
import config from "./config.js";
import store from "../store";
axios.defaults.timeout = 20000;
var JIEJINGUrl = "";
var camraUrl = "";
//axios.defaults.baseURL = config.apiUrl;
if (process.env.NODE_ENV === "development") {
  //本地
  axios.defaults.baseURL = config.apiUrltest;
  JIEJINGUrl = config.jjTesturl;
  camraUrl = config.camraTestUrl;
} else if (process.env.NODE_ENV === "production") {
  //线上
  axios.defaults.baseURL = config.apiUrl;
  JIEJINGUrl = config.jjUrl;
  camraUrl = config.camraUrl;
}
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
//启动关闭loading，配置loading
// let loading=null;
// function startLoading() {
//     console.log(Loading)
//   loading = Loading.service({
//     lock: true,
//     text: "Loading...",
//     target: document.querySelector('.loading-area')//设置加载动画区域
//   });
// }
// function endLoading() {
//     console.log(loading)
//   loading.close();
// }
// 计数请求条数，如果当前请求条数为0则关闭loading
// let needLoadingRequestCount = 0;
// function showFullScreenLoading() {

//     if (needLoadingRequestCount === 0) {
//         console.log("准备加载loading")
//         startLoading();
//     }
//     needLoadingRequestCount++;
// };
// function tryHideFullScreenLoading() {
//     if (needLoadingRequestCount <= 0) return;
//     needLoadingRequestCount--;
//     if (needLoadingRequestCount === 0) {
//       endLoading();
//     }
// };

//http request 拦截器
axios.interceptors.request.use(
  (http) => {
   
    // showFullScreenLoading();
    if (http.url.indexOf("login") > -1) {
      return http;
    }

    const token = db.get("token") || null;
    if (http.url == "/oss/file/uploadFileFlag")
      http.headers = {
        // "content-type": "application/json",
        Accept: "application/json, text/plain, */*",
        "content-type": "multipart/form-data",
      }
    if (http.url == '/common/upload')
      http.headers = {
        // "content-type": "application/json",
        Accept: "application/json, text/plain, */*",
        "content-type": "multipart/form-data",
      }
    else {
      http.data = JSON.stringify(http.data);
    }
    // log(http.url)
    // if(router.app._route.path==='/login'){
    //     return http;
    // }
    if (
      http.url === "terminal/fireAlarmControl" ||
      http.url === "terminal/sendTerminalMessage" ||
      http.url.indexOf("terminal") != -1
    ) {
      //    console.log(http)
      http.baseURL = "https://www.qutgroup.com/fcserver/";
    }
    if (http.url === "jiejing/jjstart") {
      http.baseURL = JIEJINGUrl;
    }
    if (http.url.indexOf("phpcontro") !== -1) {
      // http.baseURL = 'https://open.ys7.com/'
      // http.headers={
      // 'content-type': 'application/x-www-form-urlencoded'
      // }
    }
    if (http.url.indexOf("camera") > -1) {
      http.baseURL = camraUrl;
    }

    if (token) {
      if (config.noToken.indexOf(http.url) == -1) {
        http.headers.Authorization = token;
      }
    } else {
      router.replace({
        path: "/login",
      });
    }
 
    return http;
  },
  (error) => {
    return Promise.reject(err);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    // tryHideFullScreenLoading();
    if (response.status == 1) {
      //  Message.warning(response.errorMsg);
      Message({
        showClose: true,
        message: response.errorMsg,
        type: 'warning'
      })
    }

    if (response.status === 200) {
      if (response.data.code > 200) {
        // Message.error(response.data.msg);
        Message({
          showClose: true,
          message: response.data.msg,
          type: 'error'
        })
        switch (response.data.code) {
          // 1005: 未登录
          case 401:
            store.commit("clearUser");
            setTimeout(() => {
              router.replace({
                path: "/login",
              });
            }, 1000);
            break;

          // 清除本地token和清空vuex中token对象
          // 跳转登录页面
          // case '1004':
          //     store.commit('clearUser');
          //     // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          //     setTimeout(() => {
          //         router.replace({
          //             path: '/login'
          //         });
          //     }, 1000);
          //     break;
        }
        return Promise.reject(response);
      } else {
        return Promise.resolve(response);
      }
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    // Message.error('请求失败')
    return Promise.reject(error);
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params, _timmout = { timeout: 120000 }) {
  // console.log(url);
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        _timmout,
      })
      .then((res) => {
        // console.log(res);
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params = {}, _timmout = { timeout: 120000 }, headers = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, _timmout, headers)
      .then((res) => {
        if (res && res.data) {
          resolve(res.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function put(url, params = {}, _timmout = { timeout: 120000 }) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params, _timmout)
      .then((res) => {
        if (res && res.data) {
          resolve(res.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function remove(url, params = {}, _timmout = { timeout: 120000 }) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, params, _timmout)
      .then((res) => {
        if (res && res.data) {
          resolve(res.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function formPost(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios({
      url,
      method: "post",
      data: params,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
}
